import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowDown, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import EditorialHeader from "../compponents/EditorialHeader";
import EditorialFooter from "../compponents/EditorialFooter";
import useScrollReveal from "../hooks/useScrollReveal";
import serviceImages from "../services/serviceImages";
import "./About.css";
import "./Services.css";

export default function Services() {
  const { t } = useTranslation();
  const page = useScrollReveal();
  const services = t("serviceList", { returnObjects: true });
  return (
    <div className="about-page services-page" ref={page}>
      <a className="about-skip" href="#services-main">{t("about.design.skip")}</a>
      <EditorialHeader />
      <main id="services-main">
        <section className="services-hero about-wrap" aria-labelledby="services-title">
          <div className="services-orbits" aria-hidden="true"><Sparkles size={32} strokeWidth={1} /></div>
          <p className="about-eyebrow">{t("services.design.eyebrow")}</p>
          <h1 id="services-title">{t("services.title")}<span>.</span></h1>
          <p className="services-lead">{t("services.design.lead")}</p>
          <a className="about-scroll" href="#service-collection"><span><ArrowDown size={16} aria-hidden="true" /></span>{t("services.design.browse")}</a>
        </section>
        <section id="service-collection" className="about-wrap services-collection" aria-labelledby="collection-title">
          <div className="services-collection-heading"><h2 id="collection-title">{t("services.design.collection")}</h2><span>{String(services.length).padStart(2, "0")} / {t("services.design.paths")}</span></div>
          <div className="services-grid">
            {services.map((service, index) => (
              <article className="service-card" key={service.image} data-reveal aria-labelledby={`service-title-${index}`}>
                <Link className="service-card-image" to={`/service/${index}`} tabIndex={-1} aria-hidden="true"><img src={serviceImages[service.image]} alt="" width={600} height={450} loading={index < 2 ? "eager" : "lazy"} decoding="async" /><span className="service-number">0{index + 1}</span></Link>
                <div className="service-card-copy"><p className="about-eyebrow">{t(`services.design.${index === 4 ? "potential" : "energy"}`)}</p><h3 id={`service-title-${index}`}>{service.title}</h3><p className="service-summary">{service.description}</p><Link className="about-text-link" to={`/service/${index}`} aria-labelledby={`learn-${index} service-title-${index}`}><span id={`learn-${index}`}>{t("buttons.learnMore")}</span><ArrowUpRight size={19} aria-hidden="true" /></Link></div>
              </article>
            ))}
          </div>
        </section>
        <section className="about-connect about-wrap" aria-labelledby="services-connect" data-reveal><div><p className="about-eyebrow">{t("services.design.guidance")}</p><h2 id="services-connect">{t("services.design.connectTitle")}</h2><p>{t("services.design.connectText")}</p></div><Link className="about-button" to="/contact">{t("about.introButton")}<ArrowUpRight size={20} aria-hidden="true" /></Link></section>
      </main>
      <EditorialFooter />
    </div>
  );
}
